import { useEffect } from 'react';
import { useOpenPreviewPanel } from './useOpenPreviewPanel';

export const PreviewPanelsPostMessageListener = () => {
	const { open } = useOpenPreviewPanel();

	// Listen for messages from iframes to open preview panels
	useEffect(() => {
		const handleMessage = (event: MessageEvent) => {
			const { payload } = event.data;

			// Only handle messages with the expected type
			if (event.data?.type !== 'OPEN_PREVIEW_PANEL') {
				return;
			}

			if (payload?.url) {
				open(payload);
			}
		};

		window.addEventListener('message', handleMessage);

		return () => {
			window.removeEventListener('message', handleMessage);
		};
	}, [open]);

	return null;
};
